// extracted by mini-css-extract-plugin
module.exports = {"footerNavigation":"default_footerNavigation__E4_--","footerContainer":"default_footerContainer__2YGe4","listHeading":"default_listHeading__1t9_8","link":"default_link__n26wZ"};